
import { LogReviewFlags } from './index';

export class LogReviewFlagAdditionalValidationWatch {
   public reviewFlagAdditionalValidationWatchId: number = 0;
   public watcherUserId: number = 0;
   public reviewFlagId: number = 0;
   public tenantId: number = 0;
   public reviewFlag: LogReviewFlags = null;
}